export const VOUCHER_API_BASE_PATH = '/backoffice/voucher';

export const VOUCHER_API_ENDPOINTS = {
  LIST: VOUCHER_API_BASE_PATH,
  DETAIL: (id: string) => `${VOUCHER_API_BASE_PATH}/${id}`,
  CREATE: `${VOUCHER_API_BASE_PATH}/create`,
  UPDATE: (id: string) => `${VOUCHER_API_BASE_PATH}/${id}`,
  DELETE: `${VOUCHER_API_BASE_PATH}/delete`,
  DUPLICATE: (id: string) => `${VOUCHER_API_BASE_PATH}/${id}/duplicate`,
  CHECK_CODE: `${VOUCHER_API_BASE_PATH}/check-code`,
  UPLOAD_BANNER: `${VOUCHER_API_BASE_PATH}/upload`,
  UPLOAD_SHIPTO_CSV: `${VOUCHER_API_BASE_PATH}/upload-shipto-csv`,
  REORDER: (id: string) => `${VOUCHER_API_BASE_PATH}/${id}/reorder`,
  UPDATE_STATUS: `${VOUCHER_API_BASE_PATH}/update-status`,
  UPDATE_DISPLAY: `${VOUCHER_API_BASE_PATH}/update-display`,
  PRODUCTS: `${VOUCHER_API_BASE_PATH}/products`,
} as const;

export const DEFAULT_PRODUCT_ITEM_CODE = 0;

export const MULTIPART_FORM_HEADERS = {
  'Content-Type': 'multipart/form-data',
} as const;
